import React from 'react'

const ToolTip = ({ children, width = 'w-80' }) => {

  return (
    <div className="relative group inline-block">
      <svg className="w-4 h-4 text-text-secondary cursor-help hover:text-text-primary transition-colors" fill="none" stroke="currentColor" viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2}
          d="M8.228 9c.549-1.165 2.03-2 3.772-2 2.21 0 4 1.343 4 3 0 1.4-1.278 2.575-3.006 2.907-.542.104-.994.54-.994 1.093m0 3h.01M12 21a9 9 0 100-18 9 9 0 000 18z" />
      </svg>
      <div
        className={`absolute z-50 ${width} p-3 text-sm bg-paper border border-divider rounded-lg shadow-xl opacity-0 pointer-events-none group-hover:opacity-100 group-hover:pointer-events-auto transition-opacity duration-200 right-0 top-6`}>
        {children}
      </div>
    </div>
  )
}

export default ToolTip
